import { render, staticRenderFns } from "./ChemMcMPL4_Q10b.vue?vue&type=template&id=140e24c9&scoped=true&"
import script from "./ChemMcMPL4_Q10b.vue?vue&type=script&lang=js&"
export * from "./ChemMcMPL4_Q10b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140e24c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VForm,VSimpleTable})
